import styled from 'styled-components';
import { BaseStyledComponentProps, StyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

const TagTrailWrapper = styled('div')`
	box-sizing: border-box;
	position: relative;
	width: 100%;
	padding: 5px 48px;
`;

const Category = styled('div')`
	display: inline-block;
	margin-right: 20px;
`;

const CategoryName = styled('span')`
	font-weight: 600;
	padding-right: 5px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.contentColor};

	@media print {
		color: #000;
	}
`;

const Tag = styled('div')`
	background: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.contentColor, 15)};
	border-radius: 20px;
	display: inline-block;
	padding: 5px 10px;
	margin: 5px 5px 5px 0;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.contentColor};

	@media print {
		background: ${StyleColor.Grey100};
		color: ${StyleColor.Grey800};
	}
`;

const RemoveTag = styled('span')`
	display: inline-block;
	cursor: pointer;
	svg {
		width: 8px;
		height: 8px;
		margin-left: 5px;
		fill: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	}
`;

export {
	TagTrailWrapper,
	Category,
	CategoryName,
	Tag,
	RemoveTag,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/TagTrail/styles.ts